import { createAction, props } from '@ngrx/store';

// Load Partner Stats
export const loadPartnerStats = createAction(
    '[Partner] Load Partner Stats'
);

export const loadPartnerStatsSuccess = createAction(
    '[Partner] Load Partner Stats Success',
    props<{ 
        totalPartners: number;
        totalActivePartners: number;
        totalInactivePartners: number;
    }>()
);

export const loadPartnerStatsFailure = createAction(
    '[Partner] Load Partner Stats Failure',
    props<{ error: string }>()
);

// Update Individual Stats
export const updateTotalPartners = createAction(
    '[Partner] Update Total Partners',
    props<{ total: number }>()
);

export const updateActivePartners = createAction(
    '[Partner] Update Active Partners',
    props<{ total: number }>()
);

export const updateInactivePartners = createAction(
    '[Partner] Update Inactive Partners',
    props<{ total: number }>()
); 